import React from "react";

export default function AboutSettings() {
  return (
    <div className="section about-section">
      <p>
        <strong>Epický zpěvník</strong> was created with care for shared singing and keeping 
        the favourite songs close at hand by <strong>Marian Poljak</strong>, <strong>Lenka Poljaková</strong> and <strong>Lucian Poljak</strong>.
        The songbook harness was created by <strong>Jakub Rádl</strong>, whose open source project can be found on <a href="https://github.com/JRadl/zpevnik" target="_blank" rel="noopener noreferrer">GitHub</a>.
      </p>

      <p>
        Note that we deliberately avoided adding songs which are already well covered by other known Czech songbooks
        (unless they were too epic to not add), aiming to complement them. For example, this is the reason why this 
        songbook is much more English-heavy, so that it can be used by all the international friends singing with us.
      </p>
      <p>Listing the great Czech "math-camp" songbooks known to us and worth checking out:</p>
      <ul>
        <li>
          <a
            href="https://bratruvzpevnik.cz/#/song/0"
            target="_blank"
            rel="noopener noreferrer"
          >
            Bratrův zpěvník (from Petr Martišek)
          </a>
        </li>
        <li>
          <a
            href="https://chim.cz/zpevnik/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Oranžový zpěvník (from Michal Donát)
          </a>
        </li>
        <li>
          <a
            href="https://zpevnik.jradl.cz"
            target="_blank"
            rel="noopener noreferrer"
          >
            Jakub Rádl's zpěvník
          </a>
        </li>
        <li>
          <a
            href="https://gimli.ms.mff.cuni.cz/~viki/zpevnik/songbook.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Vikiho zpěvník (from Viktor Němeček)
          </a>
        </li>

        <li>
          <a
            href="https://www.ukulelespevnik.sk/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Citrónový ukulele zpěvník (from Michal Szabados)
          </a>
        </li>
      </ul>

      <p>
        This songbook is still under construction and constantly evolving. If you have suggestions for new songs, improvements, or corrections, we would love to hear from you.
      </p>
    </div>
  );
}
